<div class="translations-questions-list">
  <div class="translations-questions-list__header">
    <div class="translations-questions-list__header-title">
      <span class="fs__lg fw__500">Questions</span>
      @if (count$() > 0) {
        <span class="counter fs__sm fw__500">{{ count$() }} items</span>
      }
    </div>
  </div>

  <div class="translations-questions-list__list">
    <mat-action-list>
      <empathy-list-item-button
        [text]="'Welcome screen'"
        [icon]="faHandWave"
        testId="translations-question-welcome-screen"
        [active]="activeTranslationGroupKey$() === welcomeScreenGroupKey"
        (clicked)="translationsService.setActiveTranslationGroup(welcomeScreenGroupKey, true)"
      ></empathy-list-item-button>

      <mat-divider class="translations-questions-list__divider"></mat-divider>

      @if (loading$()) {
        <div class="translations-questions-list__loading">
          <mat-spinner diameter="20" color="light"></mat-spinner>
          <span class="fs__sm fw__600">Loading questions...</span>
        </div>
      } @else {
        @for (question of questions$(); track question.id) {
          <empathy-list-item-button
            [text]="question.code + '. ' + question.title"
            [icon]="questionTypeConfig[question.type].icon"
            [testId]="'translations-question-' + question.id"
            [active]="activeTranslationGroupKey$() === question.id"
            (clicked)="translationsService.setActiveTranslationGroup(question.id, true)"
          ></empathy-list-item-button>
        }
      }

      <mat-divider class="translations-questions-list__divider"></mat-divider>

      <empathy-list-item-button
        [text]="'\'Thank you\' Page'"
        [icon]="faFlagCheckered"
        testId="translations-question-thank-you-page"
        [active]="activeTranslationGroupKey$() === thankYouPageGroupKey"
        (clicked)="translationsService.setActiveTranslationGroup(thankYouPageGroupKey, true)"
      ></empathy-list-item-button>
    </mat-action-list>
  </div>
</div>
